<template>
  <div class="card">
    <div style="padding-left: 15px; padding-right: 15px">
      <div class="d-flex company-profile-top">
        <div class="company-profile-top-parent">
          <div :style="statusBadge.style" class="company-profile-badge">
            <span class="companyProfileStatusBadgeValue">{{
              statusBadge.value
            }}</span>
          </div>
          <span style="flex: 1 1 auto"></span>
          <div class="ellipsesDropdownLayout">
            <b-dropdown
              size="sm"
              variant
              right
              class="company-card-dropdown"
              toggle-class="text-decoration-none"
              no-caret
            >
              <template
                v-slot:button-content
                style="border: 0; background: none"
              >
                <i
                  class="fa fa-ellipsis-h"
                  aria-hidden="true"
                  style="color: #00000080"
                ></i>
              </template>
              <!-- <b-dropdown-item @click="downloadAsPdf">Download as PDF</b-dropdown-item> -->
              <b-dropdown-item @click="handleEditCompany" v-if="showEditCompany"
                >Edit Fund</b-dropdown-item
              >
              <!-- <b-dropdown-item>Delete</b-dropdown-item> -->
            </b-dropdown>
          </div>
        </div>
        <div class="flex-grow-1" style="text-align: center">
          <img
            :src="image"
            class="rounded-circle"
            style="width: 120px; height: 120px"
          />
        </div>
      </div>
    </div>
    <div
      class
      style="text-align: center; padding-left: 20px; padding-right: 15px"
    >
      <div class="company-profile-name">{{ fund.name }}</div>
      <div class="company-profile-sector">
        {{ fund.sector }}-{{ filterCategoryfund }}
      </div>
      <div
        class="d-flex lpCompanyCardVintageClass"
        style="justify-content: center"
      >
        Vintage :
        {{ thesisData && thesisData.length > 0 ? thesisData[0].vintage : "-" }}
      </div>
      <!-- <div class="d-flex" style="justify-content: center">
        <div v-html="starRatings">{{}}</div>
        <div class="company-profile-rating-number">{{ rating }}</div>
      </div> -->
    </div>
    <div
      style="padding-bottom: 20px; padding-left: 20px; padding-right: 15px"
      class
    >
      <table class="portfolio-company-left-table-data">
        <tr v-for="field in companyTableFields" :key="field.label">
          <th>{{ field.label }}</th>
          <td>
            <span
              style="line-height: 1.5; display: inline-block; max-width: 100%"
              v-html="field.value"
              >{{}}</span
            >
          </td>
        </tr>
      </table>
    </div>
    <div style="padding-left: 20px; padding-right: 15px">
      <div class="company-profile-company-description-title">
        Company Description
      </div>
      <div id="companyDescription" class="company-profile-company-description">
        <div v-if="fund.description && fund.description.length <= 200">
          {{ fund.description }}
        </div>
        <div
          v-if="
            fund.description &&
            fund.description.length > 200 &&
            companyDesc.length <= 200
          "
        >
          {{ companyDesc }} ...
          <span
            @click="descriptionClick('more')"
            class="company-profile-company-description-show-more-less"
            >Show more</span
          >
        </div>
        <div
          v-if="
            fund.description &&
            fund.description.length > 200 &&
            companyDesc.length > 200
          "
        >
          {{ companyDesc }}
          <span
            @click="descriptionClick('less')"
            class="company-profile-company-description-show-more-less"
            >Show less</span
          >
        </div>
      </div>
    </div>
    <div style="padding-top: 20px; padding-left: 20px; padding-right: 15px">
      <div class="company-profile-people-title" v-if="founders.length > 0">
        Founders
      </div>
      <div
        class="company-profile-people-title"
        style="color: #676767 !important"
        v-if="founders.length == 0"
      >
        Founders
      </div>
      <div v-if="founderArray && founderArray.length > 0">
        <div
          class="d-flex peoplePopOverMouseOver"
          style="padding-bottom: 10px"
          v-for="(item, index) in founderArray"
          :key="index"
          :id="'founderPopover' + item._id + index"
          @mouseover="setPopoverData(item, index)"
        >
          <b-popover
            :target="'founderPopover' + item._id + index"
            triggers="hover"
            placement="topright"
            custom-class
          >
            <div>
              <div class="row">
                <div class="col-4 peoplePopOverImage">
                  <img
                    width="77"
                    height="77"
                    class="rounded-circle"
                    v-bind:src="
                      item.image_id && item.image_id.length > 0
                        ? `${config.CRUNCHBASE_IMAGE_URL}/${item.image_id}`
                        : `${
                            item.image && item.image.length > 0
                              ? item.image
                              : 'static/img/faces/face-0.jpg'
                          }`
                    "
                  />
                </div>
                <div class="col-8">
                  <div class="peoplePopoverName">{{ item.name }}</div>
                  <div v-if="item.job_title" style>{{ item.job_title }}</div>
                  <div v-if="item.city">{{ item.city }}</div>
                  <div class="d-flex">
                    <div v-if="item.facebook_url">
                      <a
                        class="link peoplePopOverSocialMedia"
                        :href="item.facebook_url"
                        target="_blank"
                      >
                        <i class="fa fa-facebook-square" aria-hidden="true"></i>
                      </a>
                    </div>
                    <div v-if="item.url_linkedin">
                      <a
                        class="link peoplePopOverSocialMedia"
                        :href="item.url_linkedin"
                        target="_blank"
                      >
                        <i class="fa fa-linkedin-square" aria-hidden="true"></i>
                      </a>
                    </div>
                    <div v-if="item.twitter_url">
                      <a
                        class="link peoplePopOverSocialMedia"
                        :href="item.twitter_url"
                        target="_blank"
                      >
                        <i class="fa fa-twitter-square" aria-hidden="true"></i>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              <div class="d-flex" style="justify-content: space-between">
                <div v-if="num_portfolio_organization">
                  <div class="popoverTitleCls">Portfolio</div>
                  <div class="popoverValueCls">
                    {{ num_portfolio_organization }}
                  </div>
                </div>
                <div v-if="exits">
                  <div class="popoverTitleCls">Exits</div>
                  <div class="popoverValueCls">{{ exits }}</div>
                </div>
                <div v-if="investedCompanies.length">
                  <div class="popoverTitleCls">Co-invested</div>
                  <div class="popoverValueCls">
                    {{ investedCompanies.length }}
                  </div>
                </div>
              </div>
            </div>
          </b-popover>
          <div style="padding-right: 8px">
            <img
              v-bind:src="
                item.image_id && item.image_id.length > 0
                  ? `${config.CRUNCHBASE_IMAGE_URL}/${item.image_id}`
                  : `${
                      item.image && item.image.length > 0
                        ? item.image
                        : 'static/img/faces/face-0.jpg'
                    }`
              "
              width="20"
              height="20"
              class="rounded-circle"
            />
          </div>
          <div class="company-profile-people-name">{{ item.name }}</div>
        </div>
        <div
          v-if="founders.length > 3 && founderArray.length == 3"
          class="company-profile-people-more-less"
          @click="founderclick('founder', 'more')"
        >
          {{ founders.length - 3 }} more
        </div>
        <div
          v-if="founders.length > 3 && founderArray.length > 3"
          class="company-profile-people-more-less"
          @click="founderclick('founder', 'less')"
        >
          Show less
        </div>
      </div>
    </div>
    <div style="padding-top: 20px; padding-left: 20px; padding-right: 15px">
      <div class="company-profile-people-title" v-if="investors.length > 0">
        Investors
      </div>
      <div
        class="company-profile-people-title"
        style="color: #676767 !important"
        v-if="investors.length == 0"
      >
        Investors
      </div>
      <div v-if="investorArray && investorArray.length > 0">
        <div
          class="d-flex peoplePopOverMouseOver"
          style="padding-bottom: 10px"
          v-for="(item, index) in investorArray"
          :key="index"
          :id="'investorPopover' + item._id + index"
          @mouseover="setPopoverData(item, index)"
        >
          <b-popover
            :target="'investorPopover' + item._id + index"
            triggers="hover"
            placement="topright"
            custom-class
          >
            <div>
              <div class="row">
                <div class="col-4 peoplePopOverImage">
                  <img
                    width="77"
                    height="77"
                    class="rounded-circle"
                    v-bind:src="
                      item.image_id && item.image_id.length > 0
                        ? `${config.CRUNCHBASE_IMAGE_URL}/${item.image_id}`
                        : `${
                            item.image && item.image.length > 0
                              ? item.image
                              : 'static/img/faces/face-0.jpg'
                          }`
                    "
                  />
                </div>
                <div class="col-8">
                  <div class="peoplePopoverName">{{ item.name }}</div>
                  <div v-if="item.job_title" style>{{ item.job_title }}</div>
                  <div v-if="item.city">{{ item.city }}</div>
                  <div
                    v-if="item.funding_round && item.funding_round.length > 1"
                  >
                    Funding Round:{{ item.funding_round }}
                  </div>
                  <div
                    v-if="item.lead_investor && item.lead_investor.length > 1"
                  >
                    Lead Investor:{{ item.lead_investor }}
                  </div>
                  <div class="d-flex">
                    <div v-if="item.facebook_url">
                      <a
                        class="link peoplePopOverSocialMedia"
                        :href="item.facebook_url"
                        target="_blank"
                      >
                        <i class="fa fa-facebook-square" aria-hidden="true"></i>
                      </a>
                    </div>
                    <div v-if="item.url_linkedin">
                      <a
                        class="link peoplePopOverSocialMedia"
                        :href="item.url_linkedin"
                        target="_blank"
                      >
                        <i class="fa fa-linkedin-square" aria-hidden="true"></i>
                      </a>
                    </div>
                    <div v-if="item.twitter_url">
                      <a
                        class="link peoplePopOverSocialMedia"
                        :href="item.twitter_url"
                        target="_blank"
                      >
                        <i class="fa fa-twitter-square" aria-hidden="true"></i>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              <div class="d-flex" style="justify-content: space-between">
                <div v-if="num_portfolio_organization">
                  <div class="popoverTitleCls">Portfolio</div>
                  <div class="popoverValueCls">
                    {{ num_portfolio_organization }}
                  </div>
                </div>
                <div v-if="exits">
                  <div class="popoverTitleCls">Exits</div>
                  <div class="popoverValueCls">{{ exits }}</div>
                </div>
                <div v-if="investedCompanies.length">
                  <div class="popoverTitleCls">Co-invested</div>
                  <div class="popoverValueCls">
                    {{ investedCompanies.length }}
                  </div>
                </div>
              </div>
            </div>
          </b-popover>
          <div style="padding-right: 8px">
            <img
              v-bind:src="
                item.image_id && item.image_id.length > 0
                  ? `${config.CRUNCHBASE_IMAGE_URL}/${item.image_id}`
                  : `${
                      item.image && item.image.length > 0
                        ? item.image
                        : 'static/img/faces/face-0.jpg'
                    }`
              "
              width="20"
              height="20"
              class="rounded-circle"
            />
          </div>
          <div class="company-profile-people-name">{{ item.name }}</div>
        </div>
        <div
          v-if="investors.length > 5 && investorArray.length == 5"
          class="company-profile-people-more-less"
          @click="founderclick('investor', 'more')"
        >
          {{ investors.length - 5 }} more
        </div>
        <div
          v-if="investors.length > 5 && investorArray.length > 5"
          class="company-profile-people-more-less"
          @click="founderclick('investor', 'less')"
        >
          Show less
        </div>
      </div>
    </div>
    <div style="padding-top: 20px; padding-left: 20px; padding-right: 15px">
      <div class="company-profile-people-title" v-if="advisors.length > 0">
        Advisors
      </div>
      <div
        class="company-profile-people-title"
        style="color: #676767 !important"
        v-if="advisors.length == 0"
      >
        Advisors
      </div>
      <div v-if="advisorArray && advisorArray.length > 0">
        <div
          class="d-flex peoplePopOverMouseOver"
          v-for="(item, index) in advisorArray"
          :key="index"
          :id="'advisorPopover' + item._id + index"
          @mouseover="setPopoverData(item, index)"
        >
          <b-popover
            :target="'advisorPopover' + item._id + index"
            triggers="hover"
            placement="topright"
            custom-class
          >
            <div>
              <div class="row">
                <div class="col-4 peoplePopOverImage">
                  <img
                    width="77"
                    height="77"
                    class="rounded-circle"
                    v-bind:src="
                      item.image_id && item.image_id.length > 0
                        ? `${config.CRUNCHBASE_IMAGE_URL}/${item.image_id}`
                        : `${
                            item.image && item.image.length > 0
                              ? item.image
                              : 'static/img/faces/face-0.jpg'
                          }`
                    "
                  />
                </div>
                <div class="col-8">
                  <div class="peoplePopoverName">{{ item.name }}</div>
                  <div v-if="item.job_title" style>{{ item.job_title }}</div>
                  <div v-if="item.city">{{ item.city }}</div>
                  <div class="d-flex">
                    <div v-if="item.facebook_url">
                      <a
                        class="link peoplePopOverSocialMedia"
                        :href="item.facebook_url"
                        target="_blank"
                      >
                        <i class="fa fa-facebook-square" aria-hidden="true"></i>
                      </a>
                    </div>
                    <div v-if="item.url_linkedin">
                      <a
                        class="link peoplePopOverSocialMedia"
                        :href="item.url_linkedin"
                        target="_blank"
                      >
                        <i class="fa fa-linkedin-square" aria-hidden="true"></i>
                      </a>
                    </div>
                    <div v-if="item.twitter_url">
                      <a
                        class="link peoplePopOverSocialMedia"
                        :href="item.twitter_url"
                        target="_blank"
                      >
                        <i class="fa fa-twitter-square" aria-hidden="true"></i>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              <div class="d-flex" style="justify-content: space-between">
                <div v-if="num_portfolio_organization">
                  <div class="popoverTitleCls">Portfolio</div>
                  <div class="popoverValueCls">
                    {{ num_portfolio_organization }}
                  </div>
                </div>
                <div v-if="exits">
                  <div class="popoverTitleCls">Exits</div>
                  <div class="popoverValueCls">{{ exits }}</div>
                </div>
                <div v-if="investedCompanies.length">
                  <div class="popoverTitleCls">Co-invested</div>
                  <div class="popoverValueCls">
                    {{ investedCompanies.length }}
                  </div>
                </div>
              </div>
            </div>
          </b-popover>
          <div style="padding-right: 8px">
            <img
              v-bind:src="
                item.image_id && item.image_id.length > 0
                  ? `${config.CRUNCHBASE_IMAGE_URL}/${item.image_id}`
                  : `${
                      item.image && item.image.length > 0
                        ? item.image
                        : 'static/img/faces/face-0.jpg'
                    }`
              "
              width="20"
              height="20"
              class="rounded-circle"
            />
          </div>
          <div class="company-profile-people-name">{{ item.name }}</div>
        </div>
        <div
          v-if="advisors.length > 4 && advisorArray.length == 4"
          class="company-profile-people-more-less"
          @click="founderclick('advisor', 'more')"
        >
          {{ advisors.length - 4 }} more
        </div>
        <div
          v-if="advisors.length > 4 && advisorArray.length > 4"
          class="company-profile-people-more-less"
          @click="founderclick('advisor', 'less')"
        >
          Show less
        </div>
      </div>
    </div>
    <div
      style="
        padding-top: 20px;
        padding-bottom: 10px;
        padding-left: 20px;
        padding-right: 15px;
      "
    >
      <div class="company-profile-people-title" v-if="employees.length > 0">
        Employees
      </div>
      <div
        class="company-profile-people-title"
        style="color: #676767 !important"
        v-if="employees.length == 0"
      >
        Employees
      </div>
      <div v-if="employeeArray && employeeArray.length > 0">
        <div
          class="d-flex peoplePopOverMouseOver"
          v-for="(item, index) in employeeArray"
          :key="index"
          :id="'employeePopover' + item._id + index"
          @mouseover="setPopoverData(item, index)"
        >
          <b-popover
            :target="'employeePopover' + item._id + index"
            triggers="hover"
            placement="topright"
            custom-class
          >
            <div>
              <div class="row">
                <div class="col-4 peoplePopOverImage">
                  <img
                    width="77"
                    height="77"
                    class="rounded-circle"
                    v-bind:src="
                      item.image_id && item.image_id.length > 0
                        ? `${config.CRUNCHBASE_IMAGE_URL}/${item.image_id}`
                        : `${
                            item.image && item.image.length > 0
                              ? item.image
                              : 'static/img/faces/face-0.jpg'
                          }`
                    "
                  />
                </div>
                <div class="col-8">
                  <div class="peoplePopoverName">{{ item.name }}</div>
                  <div v-if="item.job_title" style>{{ item.job_title }}</div>
                  <div v-if="item.city">{{ item.city }}</div>
                  <div class="d-flex">
                    <div v-if="item.facebook_url">
                      <a
                        class="link peoplePopOverSocialMedia"
                        :href="item.facebook_url"
                        target="_blank"
                      >
                        <i class="fa fa-facebook-square" aria-hidden="true"></i>
                      </a>
                    </div>
                    <div v-if="item.url_linkedin">
                      <a
                        class="link peoplePopOverSocialMedia"
                        :href="item.url_linkedin"
                        target="_blank"
                      >
                        <i class="fa fa-linkedin-square" aria-hidden="true"></i>
                      </a>
                    </div>
                    <div v-if="item.twitter_url">
                      <a
                        class="link peoplePopOverSocialMedia"
                        :href="item.twitter_url"
                        target="_blank"
                      >
                        <i class="fa fa-twitter-square" aria-hidden="true"></i>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              <div class="d-flex" style="justify-content: space-between">
                <div v-if="num_portfolio_organization">
                  <div class="popoverTitleCls">Portfolio</div>
                  <div class="popoverValueCls">
                    {{ num_portfolio_organization }}
                  </div>
                </div>
                <div v-if="exits">
                  <div class="popoverTitleCls">Exits</div>
                  <div class="popoverValueCls">{{ exits }}</div>
                </div>
                <div v-if="investedCompanies.length">
                  <div class="popoverTitleCls">Co-invested</div>
                  <div class="popoverValueCls">
                    {{ investedCompanies.length }}
                  </div>
                </div>
              </div>
            </div>
          </b-popover>
          <div style="padding-right: 8px">
            <img
              v-bind:src="
                item.image_id && item.image_id.length > 0
                  ? `${config.CRUNCHBASE_IMAGE_URL}/${item.image_id}`
                  : `${
                      item.image && item.image.length > 0
                        ? item.image
                        : 'static/img/faces/face-0.jpg'
                    }`
              "
              width="20"
              height="20"
              class="rounded-circle"
            />
          </div>
          <div class="company-profile-people-name">{{ item.name }}</div>
        </div>
        <div
          v-if="employees.length > 4 && employeeArray.length == 4"
          class="company-profile-people-more-less"
          @click="founderclick('employee', 'more')"
        >
          {{ employees.length - 4 }} more
        </div>
        <div
          v-if="employees.length > 4 && employeeArray.length > 4"
          class="company-profile-people-more-less"
          @click="founderclick('employee', 'less')"
        >
          Show less
        </div>
      </div>
    </div>
    <editCompany
      ref="editCompanyRef"
      v-model="editCompanyModalProps"
      v-if="showEditModalPopup"
    ></editCompany>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import _ from "lodash";
import moment from "moment";
import api from "../../axios_api";
import EditCompanyDialog from "../../pages/Dashboard/Dialogs/EditCompany";
import config from "../../../config/settings";
export default {
  components: {
    [EditCompanyDialog.name]: EditCompanyDialog,
  },
  data() {
    return {
      companyDesc: "",
      founderArray: [],
      investorArray: [],
      advisorArray: [],
      employeeArray: [],
      peopleData: [],
      investors: [],
      founders: [],
      advisors: [],
      employees: [],
      employeePopover: {},
      employeeTargert: "",
      investedCompanies: [],
      exits: 0,
      num_portfolio_organization: 0,
      editCompanyModalProps: {},
      showEditModalPopup: false,
    };
  },
  computed: {
    ...mapGetters("portfolio", ["fund"]),
    ...mapGetters("contacts", ["contactData"]),
    ...mapGetters("lpAllocations", ["thesisData"]),
    ...mapGetters("role", ["getCurrentWorkspaceRolePermissions"]),
    config() {
      return config;
    },
    showEditCompany() {
      let rolePermissions = this.getCurrentWorkspaceRolePermissions;
      let index = rolePermissions.findIndex((item) => {
        if (item == "EDIT COMPANY") {
          return item;
        }
      });
      return index >= 0 ? true : false;
    },
    statusBadge() {
      let obj = {};
      this.fund.status = this.fund.status ? this.fund.status : "Unknown";
      obj.value = this.fund.status;
      if (
        this.fund.status == "Active" ||
        this.fund.status == "Unknown" ||
        this.fund.status == "Mentor" ||
        this.fund.status == "Exit"
      ) {
        obj.style =
          "margin-top:2px;background: #CBF6C5 0% 0% no-repeat padding-box;border-radius: 10px;opacity: 1;";
      } else if (this.fund.status == "Out of Business") {
        obj.value = "OB";
        obj.style =
          "margin-top:2px;background: #FACCCC 0% 0% no-repeat padding-box;border-radius: 10px;opacity: 1;";
      } else if (this.fund.status == "IPO") {
        obj.style =
          "margin-top:2px;background: #FFDFB4 0% 0% no-repeat padding-box;border-radius: 10px;opacity: 1;";
      } else if (this.fund.status == "Acquired") {
        obj.style =
          "margin-top:2px;background: #B4DCFF 0% 0% no-repeat padding-box;border-radius: 10px;opacity: 1;";
      } else {
        obj.style =
          "margin-top:2px;background: #FFDFB4 0% 0% no-repeat padding-box;border-radius: 10px;opacity: 1;";
      }
      return obj;
    },
    image() {
      return this.fund.hasOwnProperty("image_id") &&
        this.fund.image_id.length > 0
        ? `${config.CRUNCHBASE_IMAGE_URL}/${this.fund.image_id}`
        : _.isNil(this.fund.logo_url) || _.isEmpty(this.fund.logo_url)
        ? "static/img/generic-logo.png"
        : this.fund.logo_url;
    },
    filterCategoryfund() {
      let categoryfund = this.fund.category_data ? this.fund.category_data : "";
      categoryfund = categoryfund.split(",");
      return Array.from(new Set(categoryfund)).toString();
    },
    rating() {
      return _.isNil(this.fund.rating) ? 0 : this.fund.rating;
    },
    starRatings() {
      return `<p style="color: #4338AE;font-size: 11px;">
              <i class="fa fa-star ${this.rating >= 1 ? "" : "hide"}"></i>
              <i class="fa fa-star-o ${this.rating < 1 ? "" : "hide"}"></i>
              <i class="fa fa-star ${this.rating >= 2 ? "" : "hide"}" ></i>
              <i class="fa fa-star-o ${this.rating < 2 ? "" : "hide"}" ></i>
              <i class="fa fa-star ${this.rating >= 3 ? "" : "hide"}"></i>
              <i class="fa fa-star-o ${this.rating < 3 ? "" : "hide"}" ></i>
              <i class="fa fa-star ${this.rating >= 4 ? "" : "hide"}" ></i>
              <i class="fa fa-star-o ${this.rating < 4 ? "" : "hide"}" ></i>
              <i class="fa fa-star ${this.rating >= 5 ? "" : "hide"}" ></i>
              <i class="fa fa-star-o ${this.rating < 5 ? "" : "hide"}" ></i>
          </p>`;
    },
    companyTableFields() {
      this.fund.fund_status = this.fund.fund_status
        ? this.fund.fund_status
        : "-";
      this.fund.sector = this.fund.sector ? this.fund.sector : "Unknown";
      this.fund.founding_date = this.fund.founding_date
        ? this.fund.founding_date
        : "-";
      this.fund.fund_investment_date = this.fund.fund_investment_date
        ? this.fund.fund_investment_date
        : "-";
      this.fund.investor_stage = this.fund.investor_stage
        ? this.fund.investor_stage
        : "-";
      this.fund.investor_type = this.fund.investor_type
        ? this.fund.investor_type
        : "";
      this.fund.num_acquisitions = this.fund.num_acquisitions
        ? this.fund.num_acquisitions
        : 0;
      this.fund.status = this.fund.status ? this.fund.status : "Unknown";
      this.fund.company_type = this.fund.company_type
        ? this.fund.company_type
        : "-";
      this.fund.category_fund = this.fund.category_fund
        ? this.fund.category_fund
        : "-";
      this.fund.headquarters = this.fund.headquarters
        ? this.fund.headquarters
        : "-";
      this.fund.website = this.fund.website ? this.fund.website : "-";
      this.fund.facebook = this.fund.facebook ? this.fund.facebook : "-";
      this.fund.linkedin = this.fund.linkedin ? this.fund.linkedin : "-";
      this.fund.twitter = this.fund.twitter ? this.fund.twitter : "-";
      this.fund.contact_email = this.fund.contact_email
        ? this.fund.contact_email
        : "-";
      this.fund.lastFunding = this.fund.last_funding_round
        ? this.fund.last_funding_round
        : "-";
      return [
        {
          label: "Fund Status:",
          value:
            this.thesisData.length > 0 && this.thesisData[0].status
              ? this.thesisData[0].status
              : "-",
          isEditOn: false,
          isEditable: false,
        },
        {
          label: "Sector:",
          value: this.fund.sector,
          isEditOn: false,
          isEditable: false,
        },
        {
          label: "Founding Date:",
          value:
            this.fund.founding_date &&
            this.fund.founding_date != "-" &&
            this.fund.founding_date != "Invalid date"
              ? moment(this.fund.founding_date).format("MM/DD/YYYY")
              : "-",
          isEditOn: false,
          isEditable: false,
        },
        {
          label: "Investment Date:",
          value:
            this.fund.fund_investment_date &&
            this.fund.fund_investment_date != "-" &&
            this.fund.fund_investment_date != "Invalid date"
              ? moment(this.fund.fund_investment_date).format("MM/DD/YYYY")
              : "-",
          isEditOn: false,
          isEditable: false,
        },
        {
          label: "Investment Stage:",
          value: this.fund.investor_stage,
          isEditOn: false,
          isEditable: false,
        },
        {
          label: "GP Ownership %:",
          value:
            this.thesisData.length > 0 && this.thesisData[0].gpOwnership
              ? `${this.thesisData[0].gpOwnership}%`
              : `0%`,
          isEditOn: false,
          isEditable: false,
        },
        {
          label: "GP Carry %:",
          value:
            this.thesisData.length > 0 && this.thesisData[0].gpCarryProfit
              ? `${this.thesisData[0].gpCarryProfit}%`
              : `0%`,
          isEditOn: false,
          isEditable: false,
        },

        {
          label: "Investment Type:",
          value: this.fund.investor_type,
          isEditOn: false,
          isEditable: false,
        },
        {
          label: "Tags:",
          value:
            this.fund.tags && this.fund.tags.length > 0
              ? this.fund.tags.toString()
              : "",
          isEditOn: false,
          isEditable: false,
        },
        {
          label: "Number of Acquisitions:",
          value: this.fund.num_acquisitions,
          isEditOn: false,
          isEditable: false,
        },
        {
          label: "No. of Employees:",
          value: this.fund.employee_count || "-",
          isEditOn: false,
          isEditable: false,
        },
        {
          label: "Headquarters:",
          value: this.fund.headquarters,
          isEditOn: false,
          isEditable: false,
        },
        {
          label: "Website:",
          value:
            this.fund.website && this.fund.website != "-"
              ? `<a class="link" href="${this.fund.website}" target="_blank">${this.fund.website}</a>`
              : "-",
          isEditOn: false,
          isEditable: false,
        },
        {
          label: "Contact Email:",
          value:
            this.fund.contact_email && this.fund.contact_email != "-"
              ? `<a class="link" style="color: #0000009A;" href="mailto:${this.fund.contact_email}">${this.fund.contact_email}</a>`
              : "-",
          isEditOn: false,
          isEditable: false,
        },
        {
          label: "Social Media:",
          value: this.socialMedia,
          isEditOn: false,
          isEditable: false,
        },
      ];
    },
    socialMedia() {
      let html = "";
      if (
        (this.fund.facebook && this.fund.facebook != "-") ||
        (this.fund.linkedin && this.fund.linkedin != "-") ||
        (this.fund.twitter && this.fund.twitter != "-")
      ) {
        html = `<div class="d-flex">
          <div>
          <a class="link" href="${this.fund.facebook}" target="_blank" style="color: #0000009A;font-size: 18px;padding-right: 5px;">
          <i class="fa fa-facebook-square" aria-hidden="true"></i>
          </a>
          </div>
           <div>
          <a class="link" href="${this.fund.linkedin}" target="_blank" style="color: #0000009A;font-size: 18px;padding-right: 5px;">
          <i class="fa fa-linkedin-square" aria-hidden="true"></i>
          </a> 
          </div>
           <div>
          <a class="link" href="${this.fund.twitter}" target="_blank" style="color: #0000009A;font-size: 18px;padding-right: 5px;">
          <i class="fa fa-twitter-square" aria-hidden="true"></i>
          </a>
          </div>
          </div>`;
      } else {
        html = `<div style="color:#0000009A;font-size:18px">-</div>`;
      }
      return html;
    },
  },
  mounted() {
    let self = this;
    if (self.fund && self.fund.organization) {
      self.getPeopleData();
    }
    if (self.fund && self.fund.description) self.descriptionClick("less");
  },
  watch: {
    fund: function () {
      let self = this;
      if (self.fund && self.fund.organization) {
        self.getPeopleData();
      }
      if (self.fund && self.fund.description) self.descriptionClick("less");
    },
  },
  methods: {
    downloadAsPdf() {
      // let data = JSON.parse(JSON.stringify(this.fund));
      // data.pdfType = "Download as Pdf";
      // this.$toaster.success("Download In-progress...");
      // api.post("/file/uploadEmail", { encrypt: { data: data } }).then((res) => {
      //   this.$toaster.success("Download Completed");
      //   return window.open(res.data.encrypt.success);
      // });
    },
    handleEditCompany() {
      let propsData = JSON.parse(JSON.stringify(this.fund));
      propsData.initial_investment =
        propsData.initial_investment && propsData.initial_investment != "-"
          ? propsData.initial_investment
          : "";
      propsData.name =
        propsData.name && propsData.name != "-" ? propsData.name : "";
      propsData.logo_url =
        propsData.logo_url && propsData.logo_url != "-"
          ? propsData.logo_url
          : "";
      propsData.category_data =
        propsData.category_data && propsData.category_data != "-"
          ? Array.from(new Set(propsData.category_data.split(","))).toString()
          : "";
      propsData.sector =
        propsData.sector && propsData.sector != "-" ? propsData.sector : "";
      propsData.founding_date =
        propsData.founding_date && propsData.founding_date != "-"
          ? propsData.founding_date
          : "";
      propsData.stage_i_invested =
        propsData.stage_i_invested && propsData.stage_i_invested != "-"
          ? propsData.stage_i_invested
          : "";
      propsData.company_type =
        propsData.company_type && propsData.company_type != "-"
          ? propsData.company_type
          : "";
      propsData.geography =
        propsData.geography && propsData.geography != "-"
          ? propsData.geography
          : "";
      propsData.employee_count =
        propsData.employee_count && propsData.employee_count != "-"
          ? propsData.employee_count
          : "";
      propsData.website =
        propsData.website && propsData.website != "-" ? propsData.website : "";
      propsData.contact_email =
        propsData.contact_email && propsData.contact_email != "-"
          ? propsData.contact_email
          : "";
      propsData.facebook =
        propsData.facebook && propsData.facebook != "-"
          ? propsData.facebook
          : "";
      propsData.linkedin =
        propsData.linkedin && propsData.linkedin != "-"
          ? propsData.linkedin
          : "";
      propsData.twitter =
        propsData.twitter && propsData.twitter != "-" ? propsData.twitter : "";
      propsData.description =
        propsData.description && propsData.description != "-"
          ? propsData.description
          : "";
      propsData.referred_by = this.referrals;
      this.editCompanyModalProps = {
        isShow: true,
        data: propsData,
      };
      this.showEditModalPopup = true;
    },
    founderclick(context, text) {
      if (context == "founder") {
        this.founderArray = [];
        if (text == "more") {
          this.founderArray = JSON.parse(JSON.stringify(this.founders));
        } else {
          this.founderArray =
            this.founders.length > 2
              ? [this.founders[0], this.founders[1], this.founders[2]]
              : this.founders;
        }
      }
      if (context == "investor") {
        this.investorArray = [];
        if (text == "more") {
          this.investorArray = JSON.parse(JSON.stringify(this.investors));
        } else {
          this.investorArray =
            this.investors.length > 4
              ? [
                  this.investors[0],
                  this.investors[1],
                  this.investors[2],
                  this.investors[3],
                  this.investors[4],
                ]
              : this.investors;
        }
      }
      if (context == "advisor") {
        this.advisorArray = [];
        if (text == "more") {
          this.advisorArray = JSON.parse(JSON.stringify(this.advisors));
        } else {
          this.advisorArray =
            this.advisors.length > 3
              ? [
                  this.advisors[0],
                  this.advisors[1],
                  this.advisors[2],
                  this.advisors[3],
                ]
              : this.advisors;
        }
      }
      if (context == "employee") {
        this.employeeArray = [];
        if (text == "more") {
          this.employeeArray = JSON.parse(JSON.stringify(this.employees));
        } else {
          this.employeeArray =
            this.employees.length > 3
              ? [
                  this.employees[0],
                  this.employees[1],
                  this.employees[2],
                  this.employees[3],
                ]
              : this.employees;
        }
      }
    },
    setPopoverData(item, index) {
      this.employeePopover = item;
      this.employeeTargert = `peoplePopover${item._id}${index}`;
      this.investedCompanies = [];
      this.exits = 0;
      this.num_portfolio_organization = 0;
      let obj = this.contactData.find(
        (contactItem) => contactItem.master_pid == item.master_pid
      );
      if (obj) {
        this.exits = obj.num_exits;
        this.num_portfolio_organization = obj.num_portfolio_organization;
        this.investedCompanies = obj.investedCompanies;
      }
    },
    descriptionClick(text) {
      this.companyDesc = "";
      if (text == "more") {
        this.companyDesc = this.fund.description;
      } else {
        this.companyDesc =
          this.fund &&
          this.fund.description &&
          this.fund.description.length > 200
            ? this.fund.description.substr(0, 200)
            : this.fund.description;
      }
    },
    getPeopleData() {
      const self = this;
      api
        .get(`portfolio/peoples/${self.fund._id}`)
        .then((data) => {
          self.peopleData = data.data.encrypt.success;
          self.investors = _.filter(self.peopleData, function (o) {
            return (
              o.context === "investor" && o.portfolio_item === self.fund._id
            );
          });
          self.employees = _.filter(self.peopleData, function (o) {
            return (
              o.context === "employee" && o.portfolio_item === self.fund._id
            );
          });
          self.advisors = _.filter(self.peopleData, function (o) {
            return (
              o.context === "advisor" && o.portfolio_item === self.fund._id
            );
          });
          self.founders = _.filter(self.peopleData, function (o) {
            return (
              o.context === "founder" && o.portfolio_item === self.fund._id
            );
          });
          if (self.founders) {
            self.founderArray =
              self.founders.length > 2
                ? [self.founders[0], self.founders[1], self.founders[2]]
                : self.founders;
          }
          if (self.investors) {
            self.investorArray =
              self.investors.length > 4
                ? [
                    self.investors[0],
                    self.investors[1],
                    self.investors[2],
                    self.investors[3],
                    self.investors[4],
                  ]
                : self.investors;
          }
          if (self.advisors) {
            self.advisorArray =
              self.advisors.length > 3
                ? [
                    self.advisors[0],
                    self.advisors[1],
                    self.advisors[2],
                    self.advisors[3],
                  ]
                : self.advisors;
          }
          if (self.employees) {
            self.employeeArray =
              self.employees.length > 3
                ? [
                    self.employees[0],
                    self.employees[1],
                    self.employees[2],
                    self.employees[3],
                  ]
                : self.employees;
          }
        })
        .catch((err) => console.log(err));
    },
  },
};
</script>
<style>
</style>